<script lang="ts">
import { ref, computed, reactive, defineComponent, toRefs, onMounted } from "vue";
import store from "@/store";
import downImg from "@/assets/images/down-circle.png";
import downImgGreen from "@/assets/images/down-circle-green.png";
export default defineComponent({
  name: "PrintItem",
  components: {},
  setup() {
    const collapsed = ref(false);
    const themeName = computed(() => store.state.theme.themeName);
    return {
      collapsed,
      themeName,
      downImgGreen,
      downImg,
    };
  },
});
</script>
<template>
  <div class="ub ub-ver fw print-item">
    <div class="ub ub-ac ub-ps fw print-header" @click="collapsed = !collapsed">
      <img
        :src="themeName == 'green' ? downImgGreen : downImg"
        class="header-icon"
        :class="collapsed ? 'translat180' : 'translat0'"
      />
      <slot name="header"></slot>
    </div>
    <div class="ub ub-ver fw print-content" :class="collapsed ? 'collapsed' : ''">
      <slot name="body"></slot>
    </div>
  </div>
</template>
<style scoped lang="less">
.print-item {
  padding: 0px 16px;
  box-sizing: border-box;
  background-color: #fff;
}
.print-header {
  height: 36px;
  line-height: 36px;
  padding-left: 16px;
  box-sizing: border-box;
  background-color: #fafafa;
  border: 1px solid #dcdee2;
  border-top: none;
  cursor: pointer;
  font-weight: bold;
}
.header-icon {
  width: 14px;
  height: 14px;
  margin-right: 10px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2f2f2f;
}
.print-content {
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #dcdee2;
  border-top: none;
}
:deep(.ant-card-body) {
  padding: 0;
}
:deep(.ant-card-bordered) {
  border: none;
}
.collapsed {
  height: 0;
  transition: all 0.15s ease-in;
  overflow: hidden;
  padding: 0;
  border-bottom: none;
}
.translat180 {
  transform: rotate(180deg);
  transition: all 0.1s ease-in;
}
.translat0 {
  transform: rotate(0deg);
  transition: all 0.1s ease-in;
}
</style>
